export const ACCESS_LEVELS = { seller: 10, backoffice: 7 }

// Ordem que aparecerá no menu

export const HOME_MODULE = {
  title: "Início",
  route: "home",
  icon: "grid",
  module: "home",
  permission: "view"
}
export const MODULES = [
  {
    title: "Simulador",
    route: "simulator",
    name: "simulator",
    mainModule: "order-simulation",
    subMenuOpen: false,
    subMenus: [
      {
        route: "simulator",
        title: "Realizar Simulação",
        name: "simulator-select-pos"
      },
      {
        route: "plans-filter",
        title: "Consultar Planos",
        name: "plans-filter"
      }
    ],
    belongsTo: ""
  },
  {
    route: "order-menu",
    title: "Pedido",
    name: "order",
    mainModule: "order-menu",
    subMenuOpen: false,
    subMenus: [
      {
        route: "order",
        title: "Realizar Pedido",
        name: "select-pos"
      },
      {
        route: "order-list",
        title: "Listar Pedido"
      },
      {
        route: "auditorship",
        title: "Auditar Pedido"
      },
      {
        route: "opportunity-listing",
        title: "Oportunidade"
      }
    ],
    belongsTo: ""
  },
  {
    route: "offline-order-menu",
    title: "Pedido Offline",
    name: "offline-order",
    mainModule: "offline-order-menu",
    subMenuOpen: false,
    subMenus: [
      {
        route: "offline-order-list",
        title: "Listar pedidos offline"
      }
    ],
    belongsTo: ""
  },
  {
    title: "Visita",
    route: "visit-list",
    mainModule: "visit",
    subMenuOpen: false,
    subMenus: [
      {
        route: "visit-list",
        title: "Listar Visitas"
      },
      {
        route: "visit-client",
        title: "Nova Visita"
      }
    ],
    belongsTo: ""
  },
  {
    title: "Rotas",
    route: "route-list",
    mainModule: "routes",
    subMenuOpen: false,
    subMenus: [
      {
        route: "route-list",
        title: "Listar Rotas"
      },
      {
        route: "route-create",
        title: "Nova Rota"
      },
      {
        route: "route-dashboard",
        title: "Gestão de rotas"
      }
    ],
    belongsTo: ""
  },
  {
    title: "Área de Cobertura",
    route: "coverage-list",
    mainModule: "coverage-area",
    subMenuOpen: false,
    subMenus: [
      {
        route: "coverage-list",
        title: "Listar Cobertura"
      },
      {
        route: "coverage-create",
        title: "Incluir Cobertura"
      },
      {
        route: "coverage-map",
        title: "Mapa de Cobertura"
      }
    ],
    belongsTo: ""
  },
  {
    title: "Suporte",
    route: "customer-support-helper",
    mainModule: "customer-support",
    subMenuOpen: false,
    subMenus: [
      {
        route: "chat-online",
        title: "Chat Online"
      },
      {
        route: "manual",
        title: "Manuais"
      }
    ],
    belongsTo: ""
  },
  {
    title: "Comunicado",
    route: "reports",
    mainModule: "announcement",
    subMenuOpen: false,
    subMenus: [
      {
        route: "reports",
        title: "Listar Comunicado"
      },
      {
        route: "report-form",
        title: "Novo Comunicado",
        name: "report-infos"
      }
    ],
    belongsTo: ""
  },
  {
    title: "Leads",
    route: "leads",
    mainModule: "lead",
    subMenuOpen: false,
    subMenus: [
      {
        route: "lead-list",
        title: "Lista de Leads"
      }
    ]
  },
  {
    title: "Biometria",
    route: "biometry-audit-list",
    mainModule: "biometry-audit",
    subMenuOpen: false,
    subMenus: [
      {
        route: "biometry-audit-list",
        title: "Auditoria"
      }
    ]
  },
  {
    isTitleSection: true,
    title: "Gestão",
    module: "management"
  },
  {
    route: "registrations",
    title: "Cadastro",
    mainModule: "registrations",
    subMenuOpen: false,
    subMenus: [
      {
        route: "role-list",
        title: "Perfis"
      },
      {
        route: "pos-list",
        title: "Ponto de Venda"
      },
      {
        route: "chain",
        title: "Rede"
      },
      {
        route: "suspensions-list",
        title: "Suspensão"
      },
      {
        route: "user",
        title: "Usuários"
      },
      {
        route: "plan",
        title: "Painel de Planos"
      },
      {
        route: "hierarchy",
        title: "Hierarquia de Usuários"
      },
      {
        route: "hierarchy-teams",
        title: "Equipes"
      }
    ],
    belongsTo: "management"
  },
  {
    route: "enps",
    title: "NPS",
    mainModule: "enps",
    subMenuOpen: false,
    subMenus: [
      {
        route: "enps-dashboard",
        title: "Dashboard"
      },
      {
        route: "enps-list",
        title: "Lista de Avaliações"
      }
    ],
    belongsTo: "management"
  },
  {
    route: "exports",
    title: "Relatórios",
    mainModule: "exports",
    subMenuOpen: false,
    subMenus: [
      {
        route: "export-center",
        title: "Central de Exportações"
      },
      {
        route: "sales-force-map",
        title: "Mapa Força de Vendas"
      }
    ],
    belongsTo: "management"
  },
  {
    route: "surveys",
    title: "Pesquisa",
    mainModule: "surveys",
    subMenuOpen: false,
    subMenus: [
      {
        route: "surveys-listing",
        title: "Gerenciar Pesquisas"
      },
      {
        route: "survey-create",
        title: "Criar Pesquisa"
      }
    ],
    belongsTo: "management"
  },
  {
    title: "Comissionamento",
    route: "commission-rule-list",
    mainModule: "commission",
    subMenuOpen: false,
    subMenus: [
      {
        route: "commercial-value-table-list",
        title: "Tabelas Comerciais"
      },
      {
        route: "commission-rule-list",
        title: "Regras de Comissão"
      }
    ],
    belongsTo: "management"
  },
  {
    route: "settings",
    title: "Configurações",
    mainModule: "settings",
    subMenuOpen: false,
    subMenus: [
      {
        route: "terms",
        title: "Termos de Aceite"
      },
      {
        route: "provider",
        title: "Gerais"
      },
      {
        route: "note-types-list",
        title: "Gerenciar Motivos"
      },
      {
        route: "flow-list",
        title: "Fluxo de Pedidos"
      },
      {
        route: "visit-flow-list",
        title: "Fluxo de Visitas"
      },
      {
        route: "biometry-flow-list",
        title: "Fluxo de Biometria"
      },
      {
        route: "dashboards",
        title: "Gerenciar Dashboards"
      }
    ],
    belongsTo: "management"
  },
  {
    isTitleSection: true,
    title: "API",
    module: "api"
  },
  {
    route: "access-token-list",
    title: "Tokens",
    mainModule: "access-token",
    subMenuOpen: false,
    subMenus: [
      {
        route: "access-token-list",
        title: "Token de Acesso"
      }
    ],
    belongsTo: "api"
  }
]

export const ADMINISTRATION_MODULES = [
  {
    isTitleSection: true,
    title: "Administração",
    module: "administration"
  },
  {
    route: "term-of-use",
    title: "Termo de uso",
    mainModule: "term-of-use",
    subMenuOpen: false,
    subMenus: [
      {
        route: "term-of-use-create",
        title: "Incluir Termo"
      },
      {
        route: "term-of-use-list",
        title: "Listar Termos"
      }
    ],
    belongsTo: "administration"
  },
  {
    route: "tenant",
    title: "Clientes",
    mainModule: "tenant",
    subMenuOpen: false,
    subMenus: [
      {
        route: "tenant-list",
        title: "Listar Clientes"
      },
      {
        route: "tenant-create",
        title: "Novo Cliente"
      }
    ],
    belongsTo: "administration"
  }
]

export const OFFLINE_MODULES = [
  {
    route: "offline-order-menu",
    title: "Pedido Offline",
    name: "offline-order",
    mainModule: "offline-order-menu",
    subMenuOpen: false,
    subMenus: [
      {
        route: "offline-order",
        title: "Novo pedido offline",
        name: "offline-order-client"
      },
      {
        route: "offline-order-list",
        title: "Listar pedidos offline"
      }
    ]
  }
]

export const CUSTOMER_SUPPORT_ROUTES = {
  chat: "chat-online",
  manual: "manual"
}

export const GEOLOCATION_REQUIRED_ERROR = "Para executar esta funcionalidade, é necessário habilitar a geolocalização do dispositivo."
